export default __webpack_public_path__ + "static/media/parque-del-recuerdo-color.f7d32c73.svg";